export enum SubscriptionEvent {
  SUBSCRIPTION_EVENT_CREATED = 'SUBSCRIPTION_EVENT_CREATED',
  SUBSCRIPTION_EVENT_UPDATED = 'SUBSCRIPTION_EVENT_UPDATED',
  SUBSCRIPTION_EVENT_STATUS_UPDATED = 'SUBSCRIPTION_EVENT_STATUS_UPDATED',
  SUBSCRIPTION_EVENT_RENEWAL_UPDATED = 'SUBSCRIPTION_EVENT_RENEWAL_UPDATED',
  SUBSCRIPTION_EVENT_PLAN_RENEWED = 'SUBSCRIPTION_EVENT_PLAN_RENEWED',
}
